import { render, staticRenderFns } from "./service-order.vue?vue&type=template&id=6c784140&scoped=true&"
import script from "./service-order.vue?vue&type=script&lang=js&"
export * from "./service-order.vue?vue&type=script&lang=js&"
import style0 from "./service-order.vue?vue&type=style&index=0&id=6c784140&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c784140",
  null
  
)

export default component.exports